import DentelleArtiste from '../assets/dentelledartiste.jpg'
import ExpositionArt3F from '../assets/art3f.jpg'
import ImgArtFair from '../assets/affiche.jpg'
import ImgJosephBernard from '../assets/AfficheJosephBernard.jpg'
import ImgPicassoAffiche from '../assets/AffichePicasso.jpg'
import ImgAfficheElle from '../assets/AfficheElles.jpg'
import ImgTemoinsdargile from '../assets/AfficheTémoinsArgile.jpg'
import AfficheEnviedeLumière from '../assets/AfficheEnviedeLumière.jpg'
import Chagall from '../assets/expoChagall.jpg'
import Biennale from '../assets/4ème-biennale-des-métiers-dart-Vogüé.jpg'
import SalonMétier from '../assets/AfficheAgenda/salonMétierC.jpg'
import EspaceArtGallery from '../assets/AfficheAgenda/AfficheNadineGENESSE.jpg'

export default [

    {
        key: 0,
        NameArtist : "Exposition Art Contemporain",
        CategorieArtiste: "Septembre Octobre Novembre Decembre", 
        link: '/Beghi-Gabriel', 
        imgbg:   ExpositionArt3F,
        month: ["Septembre", "Octobre", "Novembre"],
        isCardHome: true,
    },
    {
        key: 1,
        NameArtist : "Exposition Sculpture",
        CategorieArtiste: "Octobre Novembre Decembre", 
        link: "www.google.fr",
        imgbg:   DentelleArtiste, 
        month: ["Decembre"],
        isCardHome: true,
    },
    {
        key: 2,
        NameArtist : "Lausanne Art FAIR",
        CategorieArtiste: "Octobre", 
        link: "www.google.fr",
        imgbg:   ImgArtFair, 
        month: ["Octobre"],
        isCardHome: true,
    },
    {
        key: 3,
        NameArtist : "Joseph Bernard",
        CategorieArtiste: "Octobre, Fevrier", 
        link: "www.google.fr",
        imgbg:   ImgJosephBernard, 
        month: ["Octobre", "Fevrier"],
        isCardHome: true,
    },
    {
        key: 4,
        NameArtist : "Picasso et la bande dessinée",
        CategorieArtiste: "Octobre Novembre Decembre Janvier", 
        link: "www.google.fr",
        imgbg:   ImgPicassoAffiche, 
        month: ["Octobre", "Novembre", "Decembre", "Janvier"],
        isCardHome: true,
    },
    {
        key: 5,
        NameArtist : "Elle sortent de leur bulles",
        CategorieArtiste: "Octobre Novembre", 
        link: "www.google.fr",
        imgbg:   ImgAfficheElle, 
        month: ["Octobre", "Novembre"],
        isCardHome: true,
    },
    {
        key: 6,
        NameArtist : "Temoins d'Argile",
        CategorieArtiste: "Octobre, Novembre, Decembre, Janvier", 
        link: "www.google.fr",
        imgbg:   ImgTemoinsdargile, 
        month: ["Octobre", "Novembre", "Decembre", "Janvier"],
        isCardHome: true,
    },
    {
        key: 7,
        NameArtist : "Envie de Lumière",
        CategorieArtiste: "Octobre, Novembre, Decembre, Janvier", 
        link: "www.google.fr",
        imgbg:   AfficheEnviedeLumière, 
        month: ["Octobre", "Novembre", "Decembre", "Janvier"],
        isCardHome: true,
    },
    {
        key: 8,
        NameArtist : "CHAGALL, Le passeur de lumière",
        CategorieArtiste: "janvier, fevrier, mars", 
        link: "www.google.fr",
        imgbg:   Chagall, 
        month: ["Janvier", "Fevrier", "Mars"],
        isCardHome: true,
    },
    {
        key: 9,
        NameArtist : "Biennale des métiers de l'art",
        CategorieArtiste: "Novembre", 
        link: "www.google.fr",
        imgbg:   Biennale, 
        month: ["Novembre"],
        isCardHome: true,
    },
    {
        key: 10,
        NameArtist : "Salon métiers et arts",
        CategorieArtiste: "Mai", 
        link: "www.google.fr",
        imgbg:   SalonMétier, 
        month: ["Mai"],
        isCardHome: true,
    },
    {
        key: 11,
        NameArtist : "Espace art gallery",
        CategorieArtiste: "Avril", 
        link: "www.google.fr",
        imgbg:   EspaceArtGallery, 
        month: ["Avril"],
        isCardHome: true,
    },
 
 
 
]
